const LOCK_VIEW = 'LOCK_VIEW';

const lockViewAction = (lockView) => (dispatch) => {
    dispatch({
        type: LOCK_VIEW,
        ...lockView
    });
};

export default lockViewAction;
